require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuung-10-14-betreuungseinrichtungen-guessing-stegersbach.json") })
        }
      }, "path---betreuung-10-14-betreuungseinrichtungen-guessing-stegersbach");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuung-10-14-betreuungseinrichtungen-guessing-stegersbach!./.cache/json/betreuung-10-14-betreuungseinrichtungen-guessing-stegersbach.json
// module id = 718
// module chunks = 231608221292675